import { ListItem, Box, AHText, AHIcon } from "arkh";
import React from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { OrgStoreWorkspaceBreadcrumbsWithoutExternalId } from "../../OrgStores/OrgStoreWorkspaceBreadcrumbs";
import { OrgScreenListItem_screen$key } from "./__generated__/OrgScreenListItem_screen.graphql";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";

export function OrgScreenListItem(props: {
  isLast: boolean;
  screen: OrgScreenListItem_screen$key;
}) {
  const intl_tokens = useIntlTokens();
  const screen = useFragment(
    graphql`
      fragment OrgScreenListItem_screen on StorecastScreen {
        name
        status
        lastUsedAtDate {
          storeFormattedDate(style: DATE_ONLY)
        }
        lastIP
        lastIPConformsToCIDR
        store {
          name
          ...OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store
        }
      }
    `,
    props.screen
  );

  return (
    <ListItem isLast={props.isLast} border="border-primary" displayMode="TABLE">
      <Box style={{ flexDirection: "row", flex: 1, alignItems: "center" }}>
        {/* Status column */}
        <Box style={{ width: "35%" }}>
          {screen.lastUsedAtDate && (
            <AHText type="detail" color="text-secondary">
              {intl_tokens.LastSeen}: {screen.lastUsedAtDate.storeFormattedDate}
            </AHText>
          )}
          {screen.lastIP && (
            <Box
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
              }}
              spaceTop="xsmall"
              gap="small"
            >
              <AHText type="detail" color="text-secondary">
                {intl_tokens.LastIP}: {screen.lastIP}
              </AHText>
              {screen.lastIPConformsToCIDR === true && (
                <AHIcon type="check" size="xsmall" color="positive" />
              )}
              {screen.lastIPConformsToCIDR === false && (
                <AHIcon type="info" size="xsmall" color="negative" />
              )}
            </Box>
          )}
        </Box>
        {/* Name column */}
        <Box style={{ width: "35%" }}>
          <ListItem.Title>{screen.name}</ListItem.Title>
          <Box
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "center",
            }}
            spaceTop="xsmall"
          >
            <AHText type="detail" color="text-secondary">
              {screen.status}
            </AHText>
          </Box>
        </Box>
        {/* Store & Workspaces column */}
        <Box style={{ flex: 1, alignItems: "flex-end" }}>
          <ListItem.SubTitle>{screen.store?.name}</ListItem.SubTitle>
          {screen.store && (
            <AHText type="detail">
              <OrgStoreWorkspaceBreadcrumbsWithoutExternalId
                store={screen.store}
              />
            </AHText>
          )}
        </Box>
      </Box>
    </ListItem>
  );
}
